<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <!-- <nav>
      <router-link to="/">Home</router-link>
      <router-link to="/about">About</router-link>
    </nav> -->
    <!-- <div class="row">
      <div class="col-2">
        <side-bar-component></side-bar-component>
      </div>
      <div class="col-10"> -->
        <router-view></router-view>
      <!-- </div>
    </div> -->
  </div>
</template>

<script>
  // import SideBarComponent from './components/SideBarComponent';
  // import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    // SideBarComponent
    // HelloWorld
  }
}
</script>

<style>
  #app {
    font-family: Poppins, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    background: #303038;
    overflow: none;
  }
   /* Estiliza a largura e cor da barra de rolagem */
::-webkit-scrollbar {
  width: 7px; /* Largura vertical */
  height: 10px; /* Altura horizontal */
}

/* Fundo da barra de rolagem */
::-webkit-scrollbar-track {
  background: #ffffff; /* Cor de fundo */
  border-radius: 10px;
}

/* Parte que se move da barra de rolagem */
::-webkit-scrollbar-thumb {
  background: #777777; /* Cor da barra */
  border-radius: 10px;
}

/* Quando o usuário passa o mouse sobre a barra */
::-webkit-scrollbar-thumb:hover {
  background: #777777;
}
</style>
